/** Hints for the login and loading screens: one at a time, every few seconds. */
export const TIPS = [
  'Press and hold (or right-click) anything for everything you can do with it, and to examine it.',
  'Carry a sack, basket or barrel: they fill before your pack does, and tip straight into any bank.',
  'Strike a glinting seam while mining, or a bite while fishing, for a bonus.',
  'Anything can be a weapon. A hatchet beats bare fists; a sword beats a hatchet.',
  'What you drop is yours alone for a minute, then anyone’s for two more.',
  'Every bank opens onto the same vault, wherever you are.',
  'Raiders struggle to see you while you sneak, and your first blow from the shadows lands hard.',
  'Touch a waystone once and you can travel to it from any other.',
  'Bram at the forge pays well for work orders, and better for fine work.',
  'Exploration 10 marks the trees, rocks and fishing spots you’ve seen on your map (M).',
  'Cook on a range rather than a fire: you burn a little less.',
  'Add friends by name in the Friends tab, and message them with /w name.',
  'Some trees only show their worth after dark, and some only in a storm.',
  'Auto retaliate (under your health) decides whether you fight back on your own.',
];
let i = Math.floor(Math.random() * TIPS.length);
/** Show tips in `el`, changing every `ms`. Returns a stop function. */
export function rotateTips(el: HTMLElement, ms = 6500) {
  const show = () => { el.classList.remove('in'); void el.offsetWidth; el.textContent = TIPS[i = (i + 1) % TIPS.length]; el.classList.add('in'); };
  show();
  const t = window.setInterval(show, ms);
  return () => clearInterval(t);
}
